import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { BookingPolicyService, SiteInfosService, WindowRefService } from '@app/core';
import { ICombineEngine } from '@app/shared/interfaces';
import * as moment from 'moment';
import { sortBy } from 'lodash';

@Component({
    selector: 'app-conditions',
    templateUrl: './conditions.component.html',
    styleUrls: ['./conditions.component.scss']
})
export class ConditionsComponent implements OnInit, AfterViewInit {
    public _NoRemborsableNoDetected: number = BookingPolicyService._NoRemborsableNoDetected;
    public _NoRemborsable: number = BookingPolicyService._NoRemborsable;
    public _FreeCancelation: number = BookingPolicyService._FreeCancelation;
    public _Flexible: number = BookingPolicyService._Flexible;

    @Input() model: { engine: ICombineEngine };
    showDescr: boolean = false;

    partial: boolean = false;
    PrePaiementPolicy: {} = {};
    NoShowPolicy: {} = {};
    AnnulationPolicy: {} = {};
    hasFlexible: boolean = false;

    constructor(private bookingPolicyService: BookingPolicyService, private siteInfosService: SiteInfosService, private winRef: WindowRefService) { }

    ngOnInit() {
        this.PrePaiementPolicy = this.getPrePaiement();
        this.NoShowPolicy = this.getNoShow();
        this.AnnulationPolicy = this.getAnnulation();
    }

    ngAfterViewInit() {
        Array.isArray(this.model.engine.combine.addedvalues) && this.model.engine.combine.addedvalues.forEach(element => {
            if (element.category == 'saleconditioninformation') {
                if (element.name == "flexible to reschedule if plans change") {
                    this.hasFlexible = true;
                }
            }
        });
    }

    private getPrePaiement() {
        return this.bookingPolicyService.getPrePaiement(this.model.engine.combine.PrePaiement);
    }
    private getNoShow() {
        return this.bookingPolicyService.getNoShow(this.model.engine.combine.noShow);
    }
    private getAnnulation() {
        let annulation: Array<any> = [];
        switch (this.model.engine.combine.annulation.typeAnnylation) {
            case BookingPolicyService._NoRemborsableNoDetected:
                annulation.push(this.bookingPolicyService.getNoRemboursable(this.model.engine.combine.annulation));
                break;
            case BookingPolicyService._NoRemborsable:
                annulation.push(this.bookingPolicyService.getNoRemboursable(this.model.engine.combine.annulation));
                break;
            case BookingPolicyService._FreeCancelation:
                annulation.push(this.bookingPolicyService.getAnnulationGratuit());
                break;
            case BookingPolicyService._Flexible:
                if (this.model.engine.combine.annulation.detail.length == 1 && this.model.engine.combine.annulation.detail[0].from == 0 && this.model.engine.combine.annulation.detail[0].to == -1) {
                    this.partial = true;
                    annulation.push(this.bookingPolicyService.getFlexibleTrans({ type: 4 }, this.model.engine.combine.annulation.detail[0]));
                    break;
                }
                for (let dataDetail of this.model.engine.combine.annulation.detail) {
                    let result = this.bookingPolicyService.getFelexible(dataDetail, this.model.engine.combine.annulation.isHours(), this.winRef.appConfigSite.start, this.siteInfosService.getEtabLastHours());
                    annulation.push(this.bookingPolicyService.getFlexibleTrans(result, dataDetail));
                }
                break;
            default:

                break;
        }
        return annulation;
    }

    showDescription() {
        this.showDescr = true;
    }
    hideDescription() {
        this.showDescr = false;
    }

    get yesterday(): string {
        return moment(this.winRef.appConfigSite.start).subtract(1, 'days').locale(this.winRef.appConfigSite.defaultlangue).format('DD MMMM YYYY');
    }
}
